import React from "react";
import numberFormat from "../utils/numberFormat";
import currencyFormat from "../utils/currencyFormat";
// Custom renderer for One Month Pt Change
export const CustomCellRenderer = ({ value }) => {
  const isPositive = value >= 0;
  return (
    <span style={{ color: isPositive ? "green" : "red" }}>
      {value}{" "}
      <span
        style={{
          transform: isPositive ? "rotate(0deg)" : "rotate(180deg)",
          fontSize: "12px",
        }}
      >
        ↑
      </span>
    </span>
  );
};

// Custom renderer for One Month Quantity Change
export const CustomQtyCellRenderer = ({ value }) => {
  const isPositive = value >=0;
  return (
    <span style={{ color: isPositive ? "green" : "red" }}>
      {numberFormat(value)}{" "}
      <span
        style={{
          transform: isPositive ? "rotate(0deg)" : "rotate(180deg)",
          fontSize: "12px",
        }}
      >
        ⇧
      </span>
    </span>
  );
};
